import { render, staticRenderFns } from "./list-element.vue?vue&type=template&id=46f617b3&scoped=true"
import script from "./list-element.vue?vue&type=script&lang=js"
export * from "./list-element.vue?vue&type=script&lang=js"
import style0 from "./list-element.vue?vue&type=style&index=0&id=46f617b3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f617b3",
  null
  
)

export default component.exports